import { ChannelAddHeader } from './ChannelAddHeader'
import ChannelMainForm from './ChannelMainForm'

const ChannelForm = () => {
  return (
    <div>
      <ChannelAddHeader />
      <ChannelMainForm />
    </div>
  )
}

export default ChannelForm
